import { useState, useEffect } from "react";
import Layout from "../components/Layout";
import api from "../lib/api";
import { Card, CardContent } from "../components/ui/card";
import { Badge } from "../components/ui/badge";
import { Users } from "@phosphor-icons/react";

export default function CommunityPage() {
  const [members, setMembers] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/community/members").then(r => { setMembers(r.data); setLoading(false); }).catch(() => setLoading(false));
  }, []);

  return (
    <Layout>
      <div className="p-6 md:p-8 lg:p-12" data-testid="community-page">
        <div className="mb-8">
          <p className="text-xs font-semibold uppercase tracking-widest text-slate-500 mb-1">Network</p>
          <h1 className="text-2xl sm:text-3xl font-bold tracking-tight text-slate-950" style={{ fontFamily: "'Outfit', sans-serif" }}>
            Community
          </h1>
          <p className="text-sm text-slate-500 mt-1">Connect with fellow learners from our free courses</p>
        </div>

        {loading ? (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
            {[1,2,3].map(i => <div key={i} className="h-24 bg-slate-100 animate-pulse" />)}
          </div>
        ) : members.length > 0 ? (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
            {members.map((m, idx) => (
              <Card key={idx} className="border border-slate-200 rounded-none shadow-sm" data-testid={`community-member-${idx}`}>
                <CardContent className="p-4 flex items-center gap-3">
                  <div className="w-10 h-10 bg-blue-800/10 rounded-full flex items-center justify-center flex-shrink-0">
                    <span className="text-sm font-bold text-blue-800">{(m.name || "?")[0].toUpperCase()}</span>
                  </div>
                  <div className="flex-1 min-w-0">
                    <p className="text-sm font-medium text-slate-900 truncate">{m.name}</p>
                    <p className="text-xs text-slate-500 truncate">{m.email}</p>
                  </div>
                  <Badge variant="outline" className="rounded-none text-[10px]">Member</Badge>
                </CardContent>
              </Card>
            ))}
          </div>
        ) : (
          <div className="text-center py-16">
            <Users size={48} className="text-slate-300 mx-auto mb-4" />
            <p className="text-lg font-medium text-slate-600">No community members yet</p>
            <p className="text-sm text-slate-500">Members appear here once they complete free courses</p>
          </div>
        )}
      </div>
    </Layout>
  );
}
